import React, { useState } from 'react';
import classnames from 'classnames';
import { Button, ButtonProps } from 'tea-component';
import SimpleModal, { ISimpleModalProps } from '@gp/components/SimpleModal';
import { BoolFlag } from '@gp/enums/common';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IReportSubmitButtonProps extends IBaseProps, Omit<ButtonProps, 'children'> {
  isEdit?: boolean;
  isDisabledSubmit?: boolean;
  isSubmitting?: boolean;
  submitType?: BoolFlag;
  modalProps?: ISimpleModalProps;
  onConfirm?: (isPublish: boolean) => void;
}

export const CONFIRM_TIPS_CFG: {
  [key: string]: {
    title: string;
    description: string | React.ReactElement;
  };
} = {
  ADD: {
    title: 'Do you want to Publish?',
    // description: (
    //   <div className="dbg-dps-report-submit-confirm-tips-list">
    //     <p className="dbg-dps-report-submit-confirm-tips-list-item">
    //       Your content will be saved and unpublished after clicking Confirm.
    //     </p>
    //     <p className="dbg-dps-report-submit-confirm-tips-list-item">
    //       Your content will be published after clicking Publish.
    //     </p>
    //   </div>
    // ),
    description: '',
  },
  EDIT: {
    title: 'Do you want to Publish?',
    // description: (
    //   <div className="dbg-dps-report-submit-confirm-tips-list">
    //     <p className="dbg-dps-report-submit-confirm-tips-list-item">
    //       Your edited content will be saved and unpublished after clicking Confirm.
    //     </p>
    //     <p className="dbg-dps-report-submit-confirm-tips-list-item">
    //       Your edited content will be published after clicking Publish.
    //     </p>
    //   </div>
    // ),
    description: '',
  },
};

const ReportSubmitButton: React.FC<IReportSubmitButtonProps> = (props) => {
  const {
    style,
    className,
    isEdit = false,
    isDisabledSubmit = false,
    isSubmitting = false,
    submitType = BoolFlag.False,
    modalProps,
    onConfirm,
    ...restProps
  } = props;

  const [visible, setVisible] = useState(false);

  const isSubmitUnpublished = submitType === BoolFlag.False;
  const isSubmitPublished = submitType === BoolFlag.True;
  const confirmTipsCfg = isEdit ? CONFIRM_TIPS_CFG.EDIT : CONFIRM_TIPS_CFG.ADD;

  return (
    <>
      <Button
        {...restProps}
        type="primary"
        style={style}
        className={classnames('dbg-dps-report-submit-btn', className)}
        disabled={isDisabledSubmit}
        onClick={(e) => {
          e?.stopPropagation();
          setVisible(true);
        }}
      >
        Submit
      </Button>
      <SimpleModal
        {...modalProps}
        className="dbg-dps-report-submit-confirm-modal"
        size="m"
        title={confirmTipsCfg.title}
        description={confirmTipsCfg.description}
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        footer={
          <>
            <Button
              type="primary"
              loading={isSubmitting && isSubmitPublished}
              disabled={isSubmitting && isSubmitUnpublished}
              onClick={(e) => {
                e?.stopPropagation();
                onConfirm?.(true);
              }}
            >
              Publish
            </Button>
            <Button
              loading={isSubmitting && isSubmitUnpublished}
              disabled={isSubmitting && isSubmitPublished}
              onClick={(e) => {
                e?.stopPropagation();
                onConfirm?.(false);
              }}
            >
              Save As Draft
            </Button>
            <Button
              onClick={(e) => {
                e?.stopPropagation();
                setVisible(false);
              }}
            >
              Cancel
            </Button>
          </>
        }
      />
    </>
  );
};

export default ReportSubmitButton;
